import { useContext } from 'react';

import { OrganizationContext } from './organization-context-object';

export type { OrganizationMemberWithProfile } from './organization-types';

export { OrganizationContext };

export const useOrganization = () => {
  const context = useContext(OrganizationContext);
  if (context === undefined) {
    throw new Error('useOrganization must be used within an OrganizationProvider');
  }
  return context;
};
